/* @flow */

import {connect} from 'react-redux';
import TranslationComponent from './translation';

const mapStateToProps = (state, props) => ({
  ...props,
  isLoading: state.locale.genericDataIsLoading,
  values: state.locale.billedTypes,
});

export default connect(mapStateToProps)(TranslationComponent);
